module.exports = {"540402100":"林芝镇","540402101":"百巴镇","540402102":"八一镇","540402103":"鲁朗镇","540402200":"更章门巴民族乡","540402201":"布久乡","540402202":"米瑞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540402.json
// module id = 2520
// module chunks = 0